import { Box, Container, IconButton, Link, Stack, Text } from '@chakra-ui/react'
import { BsTwitterX, BsXCircleFill } from 'react-icons/bs';
import { FaTwitter } from 'react-icons/fa';
import { FiX } from 'react-icons/fi'
type Props = {
    setShowBanner: any;
}
export const Banner = ({setShowBanner} : Props) => (
  <Box as="section" bgColor={"green.500"}>
    <Box borderBottomWidth="1px" bg="bg.surface">
      <Container py={{ base: '4', md: '3.5' }}>
        <Stack
          direction="row"
          spacing={{ base: '3', md: '4' }}
          justify="space-between"
          align={{ base: 'start', md: 'center' }}
        >
          <Box>
            <Text fontWeight="bold">We are on Beta!</Text>
            <Text  color="white">
              Get the app now and share your views with us on our X Account
            </Text>
          </Box>
          <IconButton as={Link} onClick={() => setShowBanner(false)} href="https://twitter.com/headsupbookmark" icon={<BsTwitterX />} variant="tertiary" aria-label="Close banner" isExternal/>
        </Stack>
      </Container>
    </Box>
  </Box>
)